import React, { useState, useEffect, useMemo } from 'react';
import { Box, Typography, Avatar } from '@mui/material';
import { LinearProgressBar } from '../../../shared';
import { useSelector } from 'react-redux';
import { getDifferenceBetweenDateRange } from '../../../../utility';
import { fetchImagesFromS3Bucket } from '../../../../utility/aws-utility';

const Websites = (props) => {
    const { website, handleModal } = props;
    const { company } = useSelector((state) => state.company);
    const { startDateRange, endDateRange } = useSelector((state) => state.filter);
    
    const hideTotalDetails = useMemo(() => {
        let isHidden = false;
        
        switch (company.id) {
        case 3: // Tepmetko
        case 16: // Bavencio
            isHidden = true;
            break;
        default:
            isHidden = false;
            break;
        }

        return isHidden;
    }, [company.id]);

    return (
        <Box className="padding-8px mt-2" onClick={handleModal} >
            <Box className="flex-row mb-12px ">
                <Box className="pr-12px">
                    <Avatar
                        alt={website?.website?.toUpperCase()}
                        className="prescriber-profile bg-primary-50 font-color-AF509C"
                        src={' '}
                    />
                </Box>
                <Box>
                    <Typography className="text-xs-medium gray-900">
                        {website.website}
                    </Typography>
                    {
                        !hideTotalDetails && <Typography className="text-xs-medium gray-500">
                            {website.action_count} Total counts this {getDifferenceBetweenDateRange(startDateRange, endDateRange)}
                        </Typography>
                    }
                    
                </Box>
            </Box>
            {
                !hideTotalDetails && <LinearProgressBar bgColor={true} tooltipText={website.action_count} value={website.action_count > 100 ? 100 : website.action_count}/>
            }
            
        </Box>
    );
};

export default React.memo(Websites);
